import _ from "lodash";
import Vue from "vue";

function updateOldStateWithSelected(state, payload) {
  let tempState = [];
  _.each(payload, payloadItem => {
    let oldPayloadItem = null;
    if (_.isObject(state)) {
      oldPayloadItem = state[payloadItem.siteID];
    }
    if (_.isArray(state)) {
      oldPayloadItem = _.find(state, {
        type: payloadItem.type,
        siteID: payloadItem.siteID,
        URI: payloadItem.URI
      });
    }
    if (oldPayloadItem) {
      payloadItem.selected = oldPayloadItem.selected;
    }
    tempState.push(payloadItem);
  });
  return tempState;
}

function updateBySiteID(state, payload) {
  let tempState = [];
  _.each(payload, payloadItem => {
    let oldPayloadItem = null;
    if (_.isObject(state)) {
      oldPayloadItem = state[payloadItem.siteID];
    }
    if (_.isArray(state)) {
      oldPayloadItem = _.find(state, {
        siteID: payloadItem.siteID
      });
    }
    if (oldPayloadItem) {
      payloadItem.selected = oldPayloadItem.selected;
    }
    tempState.push(payloadItem);
  });
  return tempState;
}

function removeEntities(state, payload) {
  let tempState = _.cloneDeep(state);
  _.each(payload, payloadItem => {
    let index = null;
    if (_.isArray(state)) {
      index = _.findIndex(tempState, {
        type: payloadItem.type,
        siteID: payloadItem.siteID,
        URI: payloadItem.URI
      });
    }
    if (index > -1) {
      tempState.splice(index, 1);
    }
  });
  return tempState;
}

function groupUpdate(oldState, payload, key, value) {
  let tempState = [];
  let startingTime = Date.now();

  let tempMap = _.keyBy(payload, payloadItem => {
    return `${payloadItem.siteID}_${payloadItem.URI}`;
  });

  tempState = _.map(oldState, oldStateItem => {
    if (tempMap[`${oldStateItem.siteID}_${oldStateItem.URI}`]) {
      let item = Object.assign({}, oldStateItem, { selected: value });
      // old
      return item;
    }
    return oldStateItem;
  });
  let end = Date.now();

  return tempState;
}

const mutations = {
  SET_APPINFO: (state, appInfo) => {
    state.appInfo = appInfo;
  },
  SET_PANEL_UPDATE_INFO: (state, payload) => {
    state.panelUpdateInfo = payload;
  },
  SET_ADDONS_UPDATE_INFO: (state, payload) => {
    state.addonsUpdateInfo = payload;
  },
  SET_SETTINGS: (state, settings) => {
    state.settings = settings;
  },
  SET_INSTALLED_ADDONS: (state, payload) => {
    state.installedAddons = payload;
  },
  SET_STATE_VARIABLE: (state, payload) => {
    state[payload.variable] = payload.value;
  },
  SET_SITES: (state, sites) => {
    _.each(sites, site => {
      site.selected = true;
    });
    state.sites = sites;
  },
  SET_GROUPS: (state, groups) => {
    groups = _.values(groups);
    _.each(groups, group => {
      group.selected = true;
      group.sites = _.values(group.sites);
      _.each(group.sites, site => {
        site.selected = true;
      });
    });
    state.groups = groups;
  },
  SET_CURRENT_GROUP: (state, payload) => {
    state.currentGroupID = payload.value;
  },
  SELECT_SITE: (state, payload) => {
    let site = payload.site;
    let value = payload.value;
    site.selected = value;
    //Vue.set(state.sites, site.siteID, site);
  },
  SELECT_SITE2: (state, payload) => {
    let site = payload.site;
    let value = payload.value;
    site.selected = value;
    Vue.set(state.sites, site.siteID, site);
  },
  SELECT_SITES: (state, payload) => {
    let value = payload.value;
    let tempObject = _.cloneDeep(state.sites);
    _.each(tempObject, site => {
      site.selected = value;
    });
    state.sites = tempObject;
  },
  SET_PANEL_HISTORY: (state, payload) => {
    state.panelHistory = payload;
  },
  SET_SITES_UPDATES: (state, payload) => {
    state.sitesUpdates = payload.updates;
    state.lastReloadTime = payload.lastReloadTime;
    state.recentCommentsCount = payload.recentCommentsCount;
    state.reloadStats = payload.reloadStats;
  },
  SELECT_GROUP_UPDATES: (state, payload) => {
    let value = payload.value;
    let sites = payload.sites;
    let tempSiteUpdates = _.cloneDeep(state.sitesUpdates);
    let tempUpdate = groupUpdate(tempSiteUpdates, sites, "selected", value);
    state.sitesUpdates = tempUpdate;
  },
  SELECT_SITE_UPDATE: (state, { site, value }) => {
    let index = _.findIndex(state.sitesUpdates, {
      type: site.type,
      siteID: site.siteID,
      URI: site.URI
    });
    site.selected = value;
    Vue.set(state.sitesUpdates, index, site);
  },
  UPDATE_SITES_UPDATES: (state, payload) => {
    state.sitesUpdates = updateOldStateWithSelected(
      state.sitesUpdates,
      payload.updates
    );
    state.lastReloadTime = payload.lastReloadTime;
    state.reloadStats = payload.reloadStats;
    state.recentCommentsCount = payload.recentCommentsCount;
  },
  REMOVE_SITES_UPDATES: (state, payload) => {
    state.sitesUpdates = removeEntities(state.sitesUpdates, payload);
  },
  UPDATE_SITES: (state, payload) => {
    state.sites = updateBySiteID(state.sites, payload);
  },
  SET_PLUGINS_AND_THEMES: (state, payload) => {
    state.pluginsAndThemes = payload;
  },
  SELECT_PLUGIN_AND_THEME: (state, { site, value }) => {
    let index = _.findIndex(state.pluginsAndThemes, {
      type: site.type,
      siteID: site.siteID,
      URI: site.URI
    });
    site.selected = value;
    Vue.set(state.pluginsAndThemes, index, site);
  },
  SELECT_GROUP_PLUGINS_AND_THEMES: (state, { sites, value }) => {
    let tempSiteUpdates = _.cloneDeep(state.pluginsAndThemes);
    let tempUpdate = groupUpdate(tempSiteUpdates, sites, "selected", value);
    //Vue.set(state.pluginsAndThemes, index, site);
    state.pluginsAndThemes = [];
    state.pluginsAndThemes = tempUpdate;
  },
  UPDATE_PLUGINS_AND_THEMES: (state, payload) => {
    state.pluginsAndThemes = updateOldStateWithSelected(
      state.pluginsAndThemes,
      payload
    );
  },
  REMOVE_PLUGINS_AND_THEMES: (state, payload) => {
    state.pluginsAndThemes = removeEntities(state.pluginsAndThemes, payload);
  },
  SELECT_UPDATES: (state, payload) => {
    let value = payload.value;
    let categories = ["themes", "plugins", "core", "translations"];
    _.each(categories, category => {
      _.each(state.sitesUpdates[category], update => {
        update.selected = value;
        _.each(update.sites, site => {
          site.selected = value;
        });
      });
    });
  },
  SET_FAVORITES: (state, payload) => {
    state.favorites = payload;
  },
  SET_CLIENT_PLUGIN_UPDATES: (state, payload) => {
    state.clientPluginUpdateSites = payload;
  },
  SET_MENUS: (state, payload) => {
    state.menus = payload
  },
  STOP_HISTORY_CHECK_CALL: (state, payload) => {
    state.stopHistoryCheckCall = payload
  },
  SET_EDIT_SITE_MENU: (state, payload) => {
    state.editSiteMenu = payload
  },
  SET_SETTINGS_MENU: (state, payload) => {
    state.settingsMenu = payload
  },
  SET_SITEINFO_MENU: (state, payload) => {
    state.siteInfoMenu = payload
  },
  SET_CURRENT_USERINFO: (state, payload) => {
    state.currentUserInfoV3 = payload
  },
  SET_INIT_PAGE: (state, payload) => {
    state.initPage = payload
  },
  API_FAILURE: (state, payload) => {

  }
};

export default mutations;
